import { API_URL } from './Api';

export const API_URN = '/v1/delegacao';

export function PESQUISAR_SISTEMAS_PJ(idCorreios, tipo) {
  return {
    url: `${API_URL}${API_URN}/sistemapj/${idCorreios}/${tipo}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function PESQUISAR_CONTRATOS_PJ(idCorreios, tipo) {
  return {
    url: `${API_URL}${API_URN}/contratopj/${idCorreios}/${tipo}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
